import styled, { css } from 'styled-components'
import { Link as LinkRouter } from 'react-router-dom'

import { TitleMd, TitleSm, TitleXs, TitleBase } from 'components/ui/Typography'
import { responsiveFontSize } from 'styles/utils'

export const LinkComponent = styled(LinkRouter)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  font-weight: 400;
  &:hover {
    color: ${({ theme }) => theme.palette.primary.dark};
    text-decoration: underline;
  }
`

export const linkCss = css`
  text-decoration: underline;
  transition-duration: 100ms;
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`

export const contentWidth = '1164px'

export const MarkdownContent = styled.div`
  ${({ theme }) => responsiveFontSize(theme.fontSizes.medium)};
  max-width: ${contentWidth};
  margin: 0 auto;

  a {
    ${linkCss};
  }
`

export const Paragraph = styled.p`
  margin: 1.25em 0;
  max-width: ${contentWidth};
`

export const H1 = styled(TitleBase).attrs({ asComp: 'h1' })`
  margin: 1em 0 1rem;
  ${responsiveFontSize('3.5rem')};
`

export const H2 = styled(TitleMd).attrs({ asComp: 'h2' })`
  margin: 2em 0 0.5em;
  padding-bottom: 0.5em;
  border-bottom: 1px solid rgba(48, 48, 48, 0.7);
`

export const H3 = styled(TitleMd).attrs({ asComp: 'h3' })`
  margin: 2em 0 1em;
`

export const H4 = styled(TitleSm).attrs({ asComp: 'h4' })`
  margin: 2em 0 1em;
`

export const H5 = styled(TitleXs).attrs({ asComp: 'h5' })`
  margin: 2em 0 1em;
`

export const H6 = styled(TitleXs).attrs({ asComp: 'h6' })`
  margin: 1.5em 0 1em;
`

export const UnorderedList = styled.ul`
  list-style: none;
  padding-inline-start: 1.5em;
  margin: 1em 0;
  max-width: ${contentWidth};

  & > li {
    width: 100%;
    margin-bottom: 0.75rem;

    p {
      display: inline;
      margin: 0;
    }

    &:before {
      content: '\\2022';
      color: ${({ theme }) => theme.palette.primary.main};
      font-weight: bold;
      display: inline-block;
      width: 1.5em;
      //margin-left: -1.5em;
    }
  }
`

export const OrderedList = styled.ol`
  list-style: none;
  counter-reset: li;
  padding-inline-start: 1.5em;
  margin: 1em 0;
  max-width: ${contentWidth};

  & > li {
    width: 100%;
    counter-increment: li;
    margin-bottom: 0.75rem;

    &::before {
      content: counter(li) '.';
      color: ${({ theme }) => theme.palette.primary.main};
      font-weight: bold;
      display: inline-block;
      width: 1.5em;
      margin-left: -1.5em;
    }
  }
`

export const Blockquote = styled.blockquote`
  ${({ theme }) => responsiveFontSize(theme.fontSizes.medium)};
  display: block;
  font-weight: 500;
  padding: 2em 0 0 1em;
  position: relative;
  margin: 3em 0;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 1em;
    height: 4px;
    width: 130px;
    background: linear-gradient(260deg, #4eac60 0%, #324a57 100%);
    border-radius: 10rem;
  }

  p {
    margin: 0;
  }
`

export const Link = styled(LinkComponent).attrs({ target: '_blank' })``

export const Image = styled.img.attrs({ lazy: true })`
  width: 100%;
  max-height: 700px;
  object-fit: contain;

  margin: 2rem 0;
  cursor: zoom-in;
  & > * {
    transition-duration: 200ms;
  }

  &:hover {
    & > * {
      transform: scale(1.02);
    }
  }
`
